import React, {
  createContext,
  useContext,
  useState,
  useEffect,
  ReactNode,
} from 'react';
import {loadData} from '../api/storage';

interface Veileder {
  id: string; // Example field
  name: string; // Example field
  [key: string]: any; // Allow additional fields if needed
}

const VeiledereContext = createContext<Veileder[] | undefined>(undefined);

export const VeiledereProvider = ({children}: {children: ReactNode}) => {
  const [veiledere, setVeiledere] = useState<Veileder[]>([]);

  useEffect(() => {
    const fetchVeiledere = async () => {
      const data: Veileder[] = await loadData();
      setVeiledere(data);
    };
    fetchVeiledere();
  }, []);

  return (
    <VeiledereContext.Provider value={veiledere}>
      {children}
    </VeiledereContext.Provider>
  );
};

// Create a custom hook to access the context
export const useVeiledere = (): Veileder[] => {
  const context = useContext(VeiledereContext);

  if (context === undefined) {
    throw new Error('useVeiledere must be used within a VeiledereProvider');
  }

  return context;
};
